import { connect } from 'react-redux'

import services from '@services'
import coordinators from '@coordinators'
import { HandleError } from '@coordinators/composed'

import { EditVendorPricingAgreementModal } from '@components/common/modal'

import { VendorPricingAgreement } from '@types'

interface State {
  user: { firstName: string; lastName: string; email: string }
  editVendorPricingAgreement: VendorPricingAgreement | null
}

const mapStateToProps = (state: State) => {
  return {
    currentUser: state.user,
    vendorPricingAgreement: state.editVendorPricingAgreement,
  }
}

const mapDispatchToProps = () => {
  const { RestService, UIService, VendorPricingAgreementsService } = services
  const { CloseEditVendorPricingAgreement, SaveVendorPricingAgreement } =
    coordinators

  const close = CloseEditVendorPricingAgreement({
    UIService,
    VendorPricingAgreementsService,
  })

  const saveVendorPricingAgreement = SaveVendorPricingAgreement({
    RestService,
    VendorPricingAgreementsService,
    HandleError,
  })

  return {
    close,
    saveVendorPricingAgreement,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditVendorPricingAgreementModal)
